<div class="table">
	<div class="content">
		<tui-scrollbar class="scrollbar">
			<div
				tuiScrollable
				#tableScrollbar
				class="content-scroll"
			>
				<div
					class="header"
					[ngStyle]="{ 'min-width.px': minTableWidth() }"
				>
					@if (isCompletedLoading()) {
						<div class="header-row">
							@for (resultColumn of resultColumns(); track resultColumn.resultSettings()?.column) {
								@let columnSettings = resultColumn.resultSettings();
								@let canSort = columnSettings.canSort;
								@let propSort = columnSettings.propSort;
								@if (checkIsVisibleColumn(columnSettings)) {
									<div
										class="header-row-item"
										[class.sortable]="canSort && propSort"
										[ngStyle]="{
											'min-width.px': columnSettings.minWidthPx,
											'max-width.px': columnSettings.maxWidthPx,
											'justify-content': columnSettings.spreadContent,
										}"
										(click)="canSort && propSort && toSort(propSort)"
									>
										<span class="header-row-item-text">{{
											columnSettings.titlePath | translate
										}}</span>
										@if (canSort && propSort) {
											<div class="header-row-item-img">
												<tui-icon
													class="header-row-item-img-icon"
													[icon]="getIconSort(propSort)"
												/>
											</div>
										}
									</div>
								}
							}
						</div>
					} @else {
						<ng-container *ngTemplateOutlet="skeletonLoading; context: { skeletons: skeletonRowsMain }" />
					}
				</div>

				@if (resultItems().length || !isCompletedLoading()) {
					<div
						class="body"
						[ngStyle]="{ 'height.px': bodyHeight(), 'min-width.px': minTableWidth() }"
					>
						@if (hasVisibleColumns()) {
							@if (isCompletedLoading()) {
								@if (isLoadingTop()) {
									<ng-container
										*ngTemplateOutlet="
											skeletonLoading;
											context: { skeletons: skeletonRowsSecondary }
										"
									/>
								}

								@for (row of resultRows(); let rowIndex = $index; track row.index) {
									@let item = row.item;
									@if (item) {
										<div
											class="body-row"
											[class.row-fade-enter]="isFirstLoad()"
											[style.--row-delay]="(rowIndex + 1) * 25 + 'ms'"
											[class.rowBorder]="resultTableSettings().rowBorder"
											[class.rowClickable]="resultTableSettings().rowClickable"
											[ngStyle]="{ 'justify-content': resultTableSettings().spreadContent }"
											(mouseenter)="setHoverRow(rowIndex)"
											(mouseleave)="setHoverRow(null)"
										>
											@if (sourceActionComponent) {
												<div
													class="body-row-actions"
													[ngStyle]="{ 'left.px': actionsPosition() }"
													[class.open]="hoveredRowIndex() === rowIndex"
												>
													<ng-container
														*ngTemplateOutlet="
															sourceActionComponent.actionsTemplate;
															context: { item }
														"
													></ng-container>
												</div>
											}
											<div
												class="body-row-wrapper"
												[class.rowBorder]="resultTableSettings().rowBorder"
												(click)="resultTableSettings().rowClickable && onClickRow(item)"
											>
												@for (
													resultColumn of resultColumns();
													track resultColumn.resultSettings()?.column
												) {
													@let columnSettings = resultColumn.resultSettings();
													@if (columnSettings && checkIsVisibleColumn(columnSettings)) {
														<div
															class="body-row-item"
															[ngClass]="columnSettings.contentView"
															[ngStyle]="{
																'min-width.px': columnSettings.minWidthPx,
																'max-width.px': columnSettings.maxWidthPx,
																'justify-content': columnSettings.spreadContent,
															}"
														>
															<ng-container
																*ngTemplateOutlet="
																	resultColumn.columnTemplate;
																	context: { item }
																"
															/>
														</div>
													}
												}
											</div>
										</div>
									} @else {
										@let dynamicRow = searchDynamicRowComponent(row);
										@if (dynamicRow) {
											<div
												class="dynamic-row"
												[class.rowBorder]="resultTableSettings().rowBorder"
											>
												<ng-container *ngTemplateOutlet="dynamicRow.template" />
											</div>
										}
									}
								}

								@if (isLoadingBottom()) {
									<ng-container
										*ngTemplateOutlet="
											skeletonLoading;
											context: { skeletons: skeletonRowsSecondary }
										"
									/>
								}
							}
						} @else {
							<ng-container *ngTemplateOutlet="noVisibleColumns" />
						}
					</div>
				} @else {
					<ng-container *ngTemplateOutlet="emptyTable" />
				}
			</div>
		</tui-scrollbar>
		<div class="footer">
			@if (sourceFooterComponent) {
				<ng-container *ngTemplateOutlet="sourceFooterComponent.footerTemplate"></ng-container>
			}
		</div>
	</div>
</div>

<ng-template
	#skeletonLoading
	let-skeletons="skeletons"
>
	<div class="skeleton">
		@for (i of skeletons; track $index) {
			<div class="skeleton-row">
				@for (resultColumn of resultColumns(); track resultColumn.resultSettings()?.column) {
					@let columnSettings = resultColumn.resultSettings();
					@if (columnSettings && checkIsVisibleColumn(columnSettings)) {
						<div
							class="skeleton-row-item"
							[tuiSkeleton]="true"
						></div>
					}
				}
			</div>
		}
	</div>
</ng-template>

<ng-template #emptyTable>
	<div class="empty-table">
		<app-empty-table [textPath]="resultTableSettings().emptyTextPath ?? ''" />
	</div>
</ng-template>

<ng-template #noVisibleColumns>
	<div class="empty-table">
		<app-empty-table textPath="table.notVisibleColumns" />
	</div>
</ng-template>
